export default __webpack_public_path__ + "static/support-sponsor-bloomberg-86f86469c25a0d86e560f001616529cb.png";